module.exports = __webpack_public_path__ + "img/verify-fail.82b5ddb9.png";